<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h2>Dance Events</h2>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm register-summer-camp section-banner-bg-1">
    <div class="container">
        <div class="row justify-content-center align-items-center">
            <div class="sec-title text-center">
                <h2>Dance <span>Nagpur</span> Dance</h2>
            </div>
        </div>
        <div class="row">

            <div class="col-md-7">
                <div class="widget_title inner-title mt-5">
                    <h4>“Dance Nagpur Dance” Rules & Regulation: </h4>
                </div>
                <ul class="list-style list-style1">
                    <li> Students are expected to be courteous and respectful at all times.</li>
                    <li> Being punctual is expected for every class. Faculty has the right to not allow students in
                        class if they are late. Prior intimation to the respective teacher of the class should be given
                        by the student in case he/she is going to be late for class under unavoidable circumstances.
                    </li>
                    <li> No eatables will be allowed in the studio or during the class.</li>
                    <li> Students must keep their cell phones on silent mode or switch them off during class activities.
                        For urgent call go outside of the class.</li>
                    <li> In case a student is unwell, he or she is requested to inform the instructor. She/he also has
                        the option to come to class, sit aside and observe the class.</li>
                    <li> Students are not allowed to use the studio space after or before class time or in the absence
                        or without the permission of a teacher.</li>
                    <li> Girls must tie their hair in a neat bun. Wearing any jewellery or accessories during the class
                        is not allowed. </li>
                    <li> Your belongings are your responsibility. </li>
                    <li> Students are also expected to carry the right footwear for their class as informed by the
                        instructor. Street shoes/outside footwear will not be allowed in class. </li>
                    <li> ID Proof required at the time of enrolment.</li>
                    <li> The Costume/dress expenses for the final showdown on event will be taken care by
                        Artists/performers. In case of queries related to it kindly connect the centre choreographer.
                    </li>
                </ul>
            </div>
            <div class="col-md-5">
                <div class="widget_title inner-title mt-5">
                    <h4 class="fw-bold">Media Coverage</h4>
                </div><iframe src="https://drive.google.com/file/d/1CboaM6ZCzmKWaRBgxnHrm9JchO5ffofx/preview"
                    height="550" width="100%"></iframe>
            </div>

        </div>

        <div class="border-line-sm"></div>
        <div class="row">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="widget_title inner-title gall-sys shadow-text-sm">
                        <h4 class="fw-bold">Photos 2024</h4>
                    </div>

                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd24-1.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd24-1.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd24-1.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd24-2.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd24-2.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd24-2.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd24-3.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd24-3.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd24-3.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd24-4.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd24-4.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd24-4.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd24-5.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd24-5.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd24-5.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd24-6.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd24-6.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd24-6.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>



                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="widget_title inner-title gall-sys shadow-text-sm">
                        <h4 class="fw-bold">Photos 2023</h4>
                    </div>

                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd24-1.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd24-1.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd24-1.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd2.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd2.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd2.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd3.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd3.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd3.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd4.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd4.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd4.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd5.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd5.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd5.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd6.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd6.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd6.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>



                        </ul>
                    </div>
                </div>
            </div>
            <!-- <form [formGroup]="registerForm" (ngSubmit)="submitForm()" class="row gx-3 comments-form contact-form">
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input wide form-group">
                            <label class="fw-bold control-label">Name <span  class="star text-danger">*</span></label>
                            <input type="text" formControlName="studentName" id="studentName" class="form-control">
                            <div *ngIf="f['studentName'].touched && f['studentName'].invalid" class="alert alert-danger">
                                <div *ngIf="f['studentName'].errors && f['studentName'].errors['required']">This Field is required.</div>
                                <div *ngIf="f['studentName'].errors && f['studentName'].errors['minlength']">This Field  is required.</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <label class="fw-bold control-label">Age <span class="star text-danger">*</span></label>
                            <select name="age"  formControlName="age" required="required" id="age" class="form-control">
                                <option value="">--Age--</option>
                                <option value="5 to 13">5 to 13 </option>
                                <option value="14 to 24">14 to 24</option>
                                <option value="25 to 40">25 to 40 </option>
                                <option value="40 and above">40 and above</option>
                            </select>

                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12 mt-3">
                        <div class="styled-input">
                            <label class="fw-bold control-label">Mobile No.</label>
                            <input type="text" formControlName="phone" maxlength="10" id="phone" class="form-control"/>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12 mt-3">
                        <div class="styled-input">
                            <label class="fw-bold control-label">Email</label>
                            <input type="email" formControlName="email" id="email" class="form-control"/>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12 mt-3">
                        <div class="styled-input">
                            <label class="fw-bold control-label">Parents Mobile No.</label>
                            <input type="text" formControlName="parentNo" maxlength="10" id="parentNo" class="form-control"/>
                            <div *ngIf="f['parentNo'].touched && f['parentNo'].invalid" class="alert alert-danger">
                                <div *ngIf="f['parentNo'].errors && f['parentNo'].errors['required']">This Field  is required.</div>
                                <div *ngIf="f['parentNo'].errors && f['parentNo'].errors['minlength']">This Field  is required.</div>
                            </div>

                        </div>
                    </div>

                    <div class="col-md-6 col-sm-12 mt-3">
                        <div class="styled-input">
                            <label class="fw-bold control-label">Parents Email</label>
                            <input type="parentEmail" formControlName="parentEmail" id="parentEmail" class="form-control"/>
                           <div *ngIf="f['parentEmail'].touched && f['parentEmail'].invalid" class="alert alert-danger">
                                <div *ngIf="f['parentEmail'].errors && f['parentEmail'].errors['required']">This Field  is required.</div>
                                <div *ngIf="f['parentEmail'].errors && f['parentEmail'].errors['minlength']">This Field  is required.</div>
                            </div>

                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12 mt-3">
                        <div class="styled-input">
                            <label class="fw-bold">School/College/Academy/Business Name</label>
                            <input type="text" formControlName="collegeName" id="collegeName" class="form-control"/>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12 mt-3">
                        <div class="styled-input">
                            <label class="fw-bold control-label">City <span class="star text-danger">*</span></label>
                            <input type="text" formControlName="city"  id="city" class="form-control"/>
                            <div *ngIf="f['city'].touched && f['city'].invalid" class="alert alert-danger">
                                <div *ngIf="f['city'].errors && f['city'].errors['required']">This Field Mobile No is required.</div>
                                <div *ngIf="f['city'].errors && f['city'].errors['minlength']">This Field  is required.</div>
                            </div>

                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12 mt-3">
                        <div class="styled-input">
                            <label class="fw-bold control-label">Event Time <span class="star text-danger">*</span></label>
                            <select name="eventTime"  formControlName="eventTime" required="required" id="eventTime" class="form-control">
                                <option value="">--Event Time--</option>
                                <option value="Morning"> Morning </option>
                                <option value="Evening"> Evening </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12 mt-3">
                        <div class="styled-input">
                            <label class="fw-bold control-label">Center Name <span class="star text-danger">*</span></label>
                            <select name="centerName"  formControlName="centerName" required="required" id="centerName" class="form-control">
                                <option value="">---Center Name---</option>
                                <option value="Jaripatka">Jaripatka</option>
                                <option value="Wadi">Wadi</option>
                                <option value="Dharampeth">Dharampeth</option>
                                <option value="Mangalwari,Sadar">Mangalwari,Sadar</option>
                                <option value="Mankapur">Mankapur</option>
                                <option value="Hingna T">Hingna T Point</option>
                                <option value="Wardhaman Nagar">Wardhaman Nagar</option>
                                <option value="Manish Nagar">Manish Nagar</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6 mt-4">
                        <div class="form-group">
                          <button class="btn button--effect-1 w-50"><span>
                              Submit</span> <span class="icon-right-arrow"></span></button>
                        </div>

                      </div>
                      <div class="col-md-12">
                        <div class="row mt-4">
                            <div class="col-md-4">
                                <h5 class="fw-bold">Jaripatka</h5>
                                <p class="size mb-0">Sant Godriwala Dham, C/o Anil Hardware Backside Jaripatka</p>
                                  <p><i class="fa fa-phone" aria-hidden="true"></i>
<a href="tel:7057979387" class="fw-bold size ps-2">7057979387</a></p>

                            </div>
                            <div class="col-md-4">
                                <h5 class="fw-bold">Dharampeth</h5>
                                <p class="size  mb-0">Community Hall, Tilak Nagar, Dharampeth.</p>
                                <p><i class="fa fa-phone" aria-hidden="true"></i>
<a href="tel:8999210108" class="fw-bold size ps-2"> 8999210108</a></p>
                            </div>
                            <div class="col-md-4">
                                <h5 class="fw-bold">Wadi</h5>
                                <p class="size  mb-0">Plot No. Q-1, Kamla Nagar, Near Lake View Apartment, Wadi Naka, Amravati Road
                                    </p><p><i class="fa fa-phone" aria-hidden="true"></i>
<a href="tel:7020837982" class="fw-bold size ps-2">7020837982.</a></p>
                            </div>
                            <div class="col-md-4">
                                <h5 class="fw-bold">Wardhaman Nagar</h5>
                                <p class="size  mb-0">Sindhu Bhavan, 74B East Wardhaman Nagar, Behind Radhakrishna Hospital
                                    </p><p><i class="fa fa-phone" aria-hidden="true"></i>
<a href="tel:7709961978" class="fw-bold size ps-2">7709961978</a></p>
                            </div>
                            <div class="col-md-4">
                                <h5 class="fw-bold">Manish Nagar</h5>
                                <p class="size  mb-0">Lakudkar Gym, 72, Pruthviraj Nagar, Opp Beltarodi Police Station</p>
                                <p><i class="fa fa-phone" aria-hidden="true"></i>
<a href="tel:8055529949" class="fw-bold size ps-2">8055529949.</a></p>
                            </div>
                            <div class="col-md-4">
                                <h5 class="fw-bold">Sadar Nagpur</h5>
                                <p class="size  mb-0">G H Raisoni College, Riaan Tower, Infront of Bath Shope, Mangalwari Road, Sadar</p>
                                <p><i class="fa fa-phone" aria-hidden="true"></i>
<a href="tel:9021347594" class="fw-bold size ps-2">9021347594.</a></p>
                            </div>
                            <div class="col-md-4">
                                <h5 class="fw-bold">Mankapur</h5>
                                <p class="size  mb-0">2nd Floor, Baseera Building, Manakapur Square, Koradi Road</p>
                                <p><i class="fa fa-phone" aria-hidden="true"></i>
<a href="tel:7972815026" class="fw-bold size ps-2">7972815026.</a></p>
                            </div>
                            <div class="col-md-4">
                                <h5 class="fw-bold">Hingna T Point</h5>
                                <p class="size  mb-0">G H Raisoni Vidhyaniketan And Jr. College. 271/B, Lake View Near Ambazari Lake, Hingna Road </p>
                                <p><i class="fa fa-phone" aria-hidden="true"></i>
<a href="tel:9637274952" class="fw-bold size ps-2">9637274952</a></p>
                            </div>
                        </div>

                      </div>
                </form> -->

        </div>
    </div>
</section>
